@if (dataReady) {
  <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="data"  [excelStyles]="excelStyles" [attr.aria-label]="gridAriaLabel"></ag-grid-angular>
} @else {
  Loading...
}


